/* eslint-disable no-shadow */
import React, { useState, useMemo, Fragment } from 'react';

import { Table } from 'react-bootstrap';
import styled from 'styled-components';

import { getMemberStatusFromParty } from '../../../services/PartiesService';
import MemberKickForm from '../../forms/MemberKickForm';
import Error from '../../stateMessage/Error';
import Modal from '../../utils/ModalComponet';
import {
  getCodeStatus,
  getInviteType,
  sortByName,
} from '../../../infrastructure/utils/parties';
import { isMobileResolution } from '../../../infrastructure/utils/common';

import MemberInfoMobile from './MemberInfoMobile';
import MemberRsvpStatus from './MemberRsvpStatus';

const StyledRemoveButton = styled.button`
  display: block;
  color: #e68080;
  font-size: 12px;
  text-decoration: underline;
  width: 121px;
  border: none;
  outline: none;
  background: none;
`;

const StyledActionCeil = styled.td`
  width: 5%;
  textalign: center;
  vertical-align: middle;
  cursor: pointer;
`;

const initialState = {
  openModal: false,
  memberId: '',
  name: '',
  errorText: 'Server Error',
  notRemove: false,
  isError: false,
};

const MemberInfo = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  members,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  creator,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  toUser,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  party,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  deleteMember,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  partyTz,
}) => {
  const [state, setState] = useState(initialState);
  const { openModal, name, memberId, errorText, notRemove, isError } = state;

  const closeModal = () => {
    setState(prev => ({ ...prev, openModal: false }));
  };

  const onRemoveClick = async event => {
    event.stopPropagation();
    const name = event.target.dataset.memberName;
    const { memberId } = event.target.dataset;
    const notRemove = await getMemberStatusFromParty(party, memberId);
    setState(prev => ({
      ...prev,
      openModal: true,
      name,
      notRemove,
      memberId,
    }));
  };

  const hideMessage = () => {
    setState(prev => ({ ...prev, isError: false }));
  };

  const toDelete = async memberToAssign => {
    try {
      await deleteMember(memberId, memberToAssign);
      setState(prev => ({ ...prev, openModal: false }));
    } catch (error) {
      setState(prev => ({ ...prev, isError: true, errorText: 'Server error' }));
    } finally {
      setTimeout(hideMessage, 5 * 1000);
    }
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const activeMembers = useMemo(() => members.sort(sortByName), [members]);

  const membersToReassign = useMemo(
    () => activeMembers.filter(member => member.memberName !== name),
    [activeMembers, name]
  );

  return (
    <Fragment>
      {isError && <Error text={errorText} />}
      <Modal
        open={openModal}
        smWidth
        closeModal={closeModal}
        cancel={closeModal}
      >
        <MemberKickForm
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          members={membersToReassign}
          notRemove={notRemove}
          name={name}
          handleOnDelete={toDelete}
          cancel={closeModal}
        />
      </Modal>
      <div>
        {isMobileResolution() ? (
          <MemberInfoMobile
            members={activeMembers}
            toUser={toUser}
            onRemoveClick={onRemoveClick}
          />
        ) : (
          <Table hover>
            <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Role</th>
                <th>RSVP Status</th>
                <th>Unique Invite Code</th>
                <th>Code Status</th>
                <th>Invite Type</th>
                {activeMembers.length !== 1 && (
                  <th>
                    <span style={{ display: 'none' }}>Actions</span>
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {activeMembers.map(member => (
                <tr
                  key={member.memberId}
                  onClick={() => toUser(member.memberId)}
                >
                  <td>
                    {member.memberName}
                    {member.memberId === creator ? (
                      <span
                        style={{
                          fontSize: '14px',
                          paddingLeft: '20px',
                          color: 'rgba(79, 79, 79, 0.7)',
                        }}
                      >
                        {' creator'}
                      </span>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{member.memberEmail}</td>
                  <td>{member.memberPhone}</td>
                  <td>{member.memberRole}</td>
                  <td>
                    <MemberRsvpStatus member={member} />
                  </td>
                  <td>{member.inviteCode}</td>
                  <td>{getCodeStatus(member, partyTz)}</td>
                  <td>{getInviteType(member)}</td>
                  {activeMembers.length !== 1 && (
                    <StyledActionCeil>
                      <StyledRemoveButton
                        onClick={onRemoveClick}
                        data-member-id={member.memberId}
                        data-member-name={member.memberName}
                      >
                        Remove Guest
                      </StyledRemoveButton>
                    </StyledActionCeil>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </Fragment>
  );
};

export default MemberInfo;
